import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() {
  }

  saveInLocalStorage(key, val): void {
    localStorage.setItem(key, val);
  }

  saveSessionStorage(key, val): void {
    sessionStorage.setItem(key, val);
  }

  getFromLocalStorage(key) {
    return JSON.parse(localStorage.getItem(key));
  }

  getDataFromLocalStorage(key) {
    return localStorage.getItem(key);
  }

  deleteAllLocalStorage() {
    localStorage.clear();
  }

  deleteAllSessionStorage() {
    sessionStorage.clear();
  }

  deleteLocalStorageByKey(key) {
    localStorage.removeItem(key);
  }
}
